import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as LabReqActions from './lab-req.actions';
import { APIService } from '../../services/api/api-service';

@Injectable()
export class LabReqEffects {
  loadLabReq$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LabReqActions.loadLabReq),
      switchMap(action => {
        return this.apiService
          .getLabReqById(action._id)
          .pipe(map(labReq => LabReqActions.loadLabReqSuccess({ labReq })));
      }),
      catchError(error => {
        console.error('Error', error);
        return of(LabReqActions.loadLabReqFailure({ error }));
      })
    )
  );

  loadLatestLabReq$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LabReqActions.loadLatestLabReq),
      switchMap(action => {
        return this.apiService
          .getLatestPatientLabReq()
          .pipe(map(labReq => LabReqActions.loadLabReqSuccess({ labReq })));
      }),
      catchError(error => {
        console.error('Error', error);
        return of(LabReqActions.loadLabReqFailure({ error }));
      })
    )
  );

  loadPatientLabReqs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LabReqActions.loadPatientLabReqs),
      switchMap(action => {
          return this.apiService
            .getPatientLabReqs(action.filters)
            .pipe(
              map(labReqs =>
                LabReqActions.loadPatientLabReqsSuccess({ labReqs })
              )
            )
        


      }),
      catchError(error => {
        console.error('Error', error);
        return of(LabReqActions.loadPatientLabReqsFailure({ error }));
      })
    )
  );

  constructor(
    private actions$: Actions,
    private apiService: APIService
  ) {}
}
